





















































































































import {
  computed,
  defineComponent,
  PropType,
  vue3Model
} from '~/utils/nuxt3-migration'
import { LoanInfoExtras } from '~/models/loan'
import { defineComponentTranslations } from '~/utils/i18n'
import { formatNumber } from '~/utils/number'
import { PIRAEUS_MORTGAGE_CONTRIBUTION } from '~/constants/loan/piraeus'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    loanInfoExtras: {
      type: Object as PropType<LoanInfoExtras>,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit }) {
    const visible = computed({
      get() {
        return props.modelValue
      },
      set(value: boolean) {
        emit('update:modelValue', value)
      }
    })

    return {
      visible,
      formatNumber,
      PIRAEUS_MORTGAGE_CONTRIBUTION
    }
  },
  i18n: defineComponentTranslations({
    fixed_installments_subtitle: {
      en: 'During the fixed interest rate period',
      el: 'Κατά τη διάρκεια του σταθερού επιτοκίου'
    },
    variable_installments_subtitle: {
      en: 'During the variable interest rate period',
      el: 'Κατά τη διάρκεια του κυμαινόμενου επιτοκίου'
    },
    total_duration_of_loan: {
      en: 'Total duration of loan',
      el: 'Συνολική διάρκεια δανείου'
    },
    fixed_interest_rate: {
      en: 'Fixed interest rate',
      el: 'Σταθερό επιτόκιο'
    },
    variable_interest_rate: {
      en: 'Variable interest rate',
      el: 'Κυμαινόμενο επιτόκιο'
    },
    variable_interest_analysis: {
      en: 'Variable interest analysis',
      el: 'Ανάλυση κυμαινόμενου επιτοκίου:'
    },
    loan_fees_subtitle: {
      en: "According to the Bank's Fee Pricetable",
      el: 'Σύμφωνα με το Τιμολόγιο Προμηθειών της Τράπεζας'
    }
  })
})
